module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multi-step__controls",
    class: {
      'active': _vm.active
    }
  }, [_c('Btn', {
    attrs: {
      "label": "Label_Previous",
      "disabled": _vm.firststep
    },
    on: {
      "click": function($event) {
        return _vm.lastStep()
      }
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_Next",
      "disabled": _vm.laststep || _vm.nextDisabled
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }), _vm._v(" "), (_vm.laststep) ? _c('Btn', {
    attrs: {
      "float": "right",
      "label": "Label_SaveButton"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8dd7a76!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/multi-steps/Controls.vue
// module id = 754
// module chunks = 1